import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanLoad,
  UrlTree,
} from '@angular/router';
import { AuthenticationService, WebStorageService } from '../services/index';
import constants from '../utility/constants';

@Injectable({ providedIn: 'root' })
export class AuthFrontRoleGuard implements CanLoad, CanActivate {
  private readonly userTypes = constants.common.loginType;

  constructor(
    private authenticationService: AuthenticationService,
    private storage: WebStorageService
  ) {}

  canLoad(): boolean | UrlTree {
    const currentRole = this.storage.getSessionUser();
    let currentUser = this.storage.getBuyer()?.loggedIn;
    if (currentUser) {
      if (currentRole && currentRole !== this.userTypes.public) {
        // role not authorised so redirect to home page
        this.authenticationService.logout(currentRole);
        return false;
      }
    }
    return true;
  }

  canActivate() {
    const currentRole = this.storage.getSessionUser();
    let currentUser = this.storage.getBuyer()?.loggedIn;
    if (currentUser) {
      if (currentRole && currentRole !== this.userTypes.public) {
        // role not authorised so redirect to home page
        this.authenticationService.logout(currentRole);
        return false;
      }
    }
    // authorised so return true
    return true;
  }
}
